
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexDY_45i3TP_45z5yIG0w3ZiRBSbXjLb2Dps3a_45YvzmedF7OsMeta } from "/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/index.vue?macro=true";
import { default as indexOl2rZ7LXg9gRdQmpkrUVIseOz6vD5mOrHB582Xwx76kMeta } from "/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/sign-in/index.vue?macro=true";
import { default as indexsXue7MbKyw4eFguwtOntNtRKmaDzB2tPNiMx4OQDz40Meta } from "/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/event/[id]/index.vue?macro=true";
import { default as indexFjf_96BjhSPgW6w1oMcSU8VzQkrYffyqKZDhFZWvw54Meta } from "/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/auth/callback/index.vue?macro=true";
import { default as indexzbnHdxTzo5h2IiOTf7XgsVI6rVLeFdbkPmqIHA077E4Meta } from "/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/event/[id]/check-in/index.vue?macro=true";
import { default as indexe_45R4X8JpwQUOPKot3TbntB_45uh8hER4rx2Cfn_22DKTsMeta } from "/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/event/[id]/dashboard/index.vue?macro=true";
import { default as indexjMEBNN51jngAvjHZMTDy_45alETFy909tFXeNGwhUUbrgMeta } from "/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/event/[id]/participant/index.vue?macro=true";
import { default as indexUPaphXM_GXHGBnE1d58R5Kldk4lHahruOLECN2o9mCkMeta } from "/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/event/[id]/registration/[registration_id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    component: () => import("/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/sign-in/index.vue")
  },
  {
    name: "event-id",
    path: "/event/:id()",
    component: () => import("/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/event/[id]/index.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    component: () => import("/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/auth/callback/index.vue")
  },
  {
    name: "event-id-check-in",
    path: "/event/:id()/check-in",
    component: () => import("/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/event/[id]/check-in/index.vue")
  },
  {
    name: "event-id-dashboard",
    path: "/event/:id()/dashboard",
    component: () => import("/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/event/[id]/dashboard/index.vue")
  },
  {
    name: "event-id-participant",
    path: "/event/:id()/participant",
    component: () => import("/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/event/[id]/participant/index.vue")
  },
  {
    name: "event-id-registration-registration_id",
    path: "/event/:id()/registration/:registration_id()",
    component: () => import("/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/page/event/[id]/registration/[registration_id]/index.vue")
  }
]